<template>
  <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
    <ElFormItem label="中间件游戏">
      <el-select v-model="formData.mgameId" @change="queryAction" filterable clearable placeholder="全部">
        <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </ElFormItem>

    <ElFormItem label="关键词搜索">
      <ElInput
        v-model.trim="formData.keyWord"
        placeholder="请输入关键词"
        clearable
        style="width: 220px"
        @clear="queryAction"
        @keyup.enter.native="queryAction"
      >
        <i slot="append" @click="queryAction" class="el-icon-search"></i>
      </ElInput>
    </ElFormItem>
    <ElFormItem class="bg-transparent">
      <el-button type="primary" @click="queryAction">查询</el-button>
    </ElFormItem>
  </ElForm>
</template>

<script setup>
import { ref, computed } from 'vue'
import { initPageData, MID_GAMES } from '@/data/global-opts'
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([MID_GAMES])

const gameGroups = computed(PAGE_REQUIRED_OPTS.MID_GAMES)

// eslint-disable-next-line
const emits = defineEmits(['query'])

const formData = ref({
  mgameId: '',
  keyWord: ''
})

const queryAction = () => {
  emits('query')
}

// eslint-disable-next-line
defineExpose({
  getForm: () => formData.value
})
</script>

<style scoped lang="scss"></style>
